
import { Reducer } from "redux";
import { NotificationModel } from "../common/models/CommonModels";

export enum ActionType {
    Add = "NOTIFICATION/ADD",
    Delete = "NOTIFICATION/DELETE",
    RequestUnreadNotifications = "NOTIFICATION/REQUEST_UNREAD_NOTIFICATIONS",
    ReceivedUnreadNotifications = "NOTIFICATION/RECEIVED_UNREAD_NOTIFICATIONS",
    CreateNotification = "NOTIFICATION/CREATE_NOTIFICATION",
    SetNotificationRead = "NOTIFICATION/SET_READ"
}

interface AddNotificationAction {
    type: ActionType.Add,
    data: NotificationData
}

interface DeleteNotificationAction {
    type: ActionType.Delete,
    id: string
}

export interface CreateNotification {
    type: ActionType.CreateNotification
    notification: NotificationModel
}

export interface SetNotificationRead {
    type: ActionType.SetNotificationRead
    id: string
}

type NotificationVariant = "success" | "error" | "info"

interface NotificationData {
    variant: NotificationVariant;
    message: string;
    id: string;
    autohide?: boolean | undefined;
    goTo?: string | undefined;
}

type NotificationAction = AddNotificationAction | DeleteNotificationAction;

export const actionCreators = {
    addNotification: (data: NotificationData) => <AddNotificationAction>{ type: ActionType.Add, data },
    deleteNotification: (id: string) => <DeleteNotificationAction>{ type: ActionType.Delete, id },
    createNewNotification: (notification: NotificationModel) => <CreateNotification>{ type: ActionType.CreateNotification, notification },
    setNotificationRead: (id: string) => <SetNotificationRead>{ type: ActionType.SetNotificationRead, id }
};

export interface NotificationState {
    notifications: NotificationData[]
}

const initialState = (): NotificationState => {
    return {
        notifications: [],
    }
}

export const reducer: Reducer<NotificationState> = (state: NotificationState, action: any) => {
    switch (action.type) {
        case ActionType.Add:
            return {
                ...state,
                notifications: [...state.notifications, action.data],
            }
        case ActionType.Delete:

            const nots = action.id === "" ? [] : state.notifications.filter(item => item.id !== action.id);

            return {
                ...state,
                notifications: nots
            }
    }
    return state || initialState();
}


// WEBPACK FOOTER //
// ./src/notifications/notificationsStore.ts